import { Grid } from "@mui/material";
import { Text } from "common/text";
import ReactImageFallback from "react-image-fallback";

export const InfoIdentity = ({ user }) => {
    
    return (
        <Grid container spacing={2}>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <Text>Mặt trước CCCD</Text>
                    <ReactImageFallback
                        src={user?.identity_front}
                        alt={'identity'}
                        fallbackImage={'/img/grid-default.png'}
                        style={{width: 280, height: 'auto'}}
                    />
                </div>
            </Grid>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <Text>Mặt sau CCCD</Text>
                    <ReactImageFallback
                        src={user?.identity_back}
                        alt={'identity'}
                        fallbackImage={'/img/grid-default.png'}
                        style={{width: 280, height: 'auto'}}
                    />
                </div>
            </Grid>
        </Grid>
    ) 
}